import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { recipe } from "@vanilla-extract/recipes";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";

export const searchPropertySelectStyle = recipe({
  base: {
    maxWidth: rem(460),
    margin: "0 auto",
    overflow: "hidden",
  },
  variants: {
    width: {
      stretch: {
        maxWidth: "100%",
        width: "100%",
      },
    },
    selected: {
      true: {
        cursor: "default",
        backgroundColor: theme.colors.panel,
        borderColor: `transparent !important`,
        padding: theme.spacings.s,
      },
    },
  },
});

export const searchStateContainerStyle = style({
  minHeight: rem(20),
});

export const popupContentStyle = style({
  padding: theme.spacings.s,
});

export const notFoundCTAContainerStyle = style({
  alignItems: "center",
});

export const imageContainerStyle = style({
  borderRadius: theme.borderRadiuses.xs,
  border: "none",
  display: "none",
  ...responsiveContainer({
    500: {
      display: "block",
      width: rem(160),
      height: rem(116),
    },
  }),
});

export const houseContainerStyle = style({
  width: "100%",
  flexDirection: "column",
  overflow: "hidden",
  ...responsiveContainer({
    500: {
      flexDirection: "row",
    },
  }),
});

export const houseChipStyle = style({
  alignSelf: "flex-start",
});
